import { render, staticRenderFns } from "./TheRegisterPhone.vue?vue&type=template&id=306dacbc&scoped=true&"
import script from "./TheRegisterPhone.vue?vue&type=script&lang=js&"
export * from "./TheRegisterPhone.vue?vue&type=script&lang=js&"
import style0 from "./TheRegisterPhone.vue?vue&type=style&index=0&id=306dacbc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306dacbc",
  null
  
)

export default component.exports